import { integrationOptionProvider } from "@p0security/integrations-installer";

import type { CustomIntegrationInstaller } from "./types.ts";

const iamAssessmentInstructions: CustomIntegrationInstaller["components"]["iam-assessment"]["instructions"] =
  () => ({
    help: (
      <>
        Custom assessment allows P0 to assess custom resources and identities
        that you define. This component enables you to upload custom data for
        security analysis.
      </>
    ),
    commands: {
      shell: [],
      iac: [],
    },
  });

const customIamAssessmentInstaller: CustomIntegrationInstaller["components"]["iam-assessment"] =
  {
    instructions: iamAssessmentInstructions,
    items: {},
  };

const customResourceInstaller: CustomIntegrationInstaller["components"]["iam-write"] =
  {
    items: {
      service: {
        options: {
          azure: {
            items: {
              service: {
                optionProvider: integrationOptionProvider("iam-write", [
                  {
                    integration: "azure",
                    component: "function-caller",
                    keyPrefix: "azure",
                  },
                ]),
              },
            },
          },
          aws: {
            items: {
              lambda: {
                optionProvider: integrationOptionProvider("iam-write", [
                  {
                    integration: "aws",
                    component: "function-caller",
                    keyPrefix: "aws",
                  },
                ]),
              },
            },
          },
          gcp: {
            items: {
              cloudRun: {
                optionProvider: integrationOptionProvider("iam-write", [
                  {
                    integration: "gcloud",
                    component: "function-caller",
                    keyPrefix: "gcp",
                  },
                ]),
              },
            },
          },
        },
      },
    },
    prerequisiteMessages: async (context) => {
      const provider = integrationOptionProvider("iam-write", [
        {
          component: "function-caller",
          integration: "aws",
          keyPrefix: "aws",
        },
        {
          component: "function-caller",
          integration: "gcloud",
          keyPrefix: "gcp",
        },
      ]);
      const options = await provider(context);
      if (!options.length)
        return (
          <div>
            Requires installed &quot;AWS or GCP Function Caller&quot; component
          </div>
        );
    },
  };

export const customInstaller: CustomIntegrationInstaller = {
  components: {
    base: {},
    "iam-write": customResourceInstaller,
    "iam-assessment": customIamAssessmentInstaller,
  },
};
